import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const getAccordionAnchors = (state: ApplicationState) => {
    return state.toolkit.components.accordion.anchors;
};

export const getAccordionAnchorById = (state: ApplicationState, id: string) => {
    return getAccordionAnchors(state).find(x => x.id === id) || null;
};
